document.addEventListener('DOMContentLoaded', function() {
  const audioPlayers = document.querySelectorAll('.audio-player');

  audioPlayers.forEach(audio => {
    audio.addEventListener('play', () => {
      // Pause all other audio players
      audioPlayers.forEach(otherAudio => {
        if (otherAudio !== audio) {
          otherAudio.pause();
        }
      });
    });
  });
});
